module.exports = __webpack_public_path__ + "img/about_2.cfb8c13f.jpg";